<!-- ACTIVATION VIEW LAYOUT -->
<div class="flex flex-col flex-auto min-w-0">
  <!-- HEADER -->
  <div class="bg-card">
    <div
      class="flex flex-col items-center justify-center w-full max-w-screen-xl gap-4 px-6 mx-auto my-5 sm:flex-row sm:justify-start sm:px-8"
    >
      <div class="flex items-center justify-center p-2 rounded-full  {{ bgColorClass }}">
        @if (hasFuseCompatibleIcon) {
          <mat-icon class="text-white" [svgIcon]="'{{ svgIcon }}'"></mat-icon>
        }
        @if (!hasFuseCompatibleIcon) {
          <mat-icon
            class="text-white bp-fa-icon {{ iconClass }}"
            [svgIcon]="'heroicons_outline:cube-transparent'"
          ></mat-icon>
        }
      </div>
      <div class="text-3xl font-semibold leading-7 tracking-tight md:text-4xl md:leading-snug">
        {{ title }}
      </div>
    </div>
  </div>
  <!-- / HEADER -->

  <!-- DESCRIPTION -->
  <div class="{{ bgColorClass }}">
    <div class="flex items-center justify-between w-full max-w-screen-xl px-6 py-5 mx-auto sm:px-8">
      <div class="text-2xl font-semibold text-center text-white sm:w-4/6 lg:w-3/6 sm:text-left">
        {{ description }}
      </div>
      <img class="hidden w-20 sm:block" src="assets/img/auxi/betterplan-b-light.svg" alt="" />
    </div>
  </div>
  <!-- / DESCRIPTION -->

  <!-- MAIN -->
  <div
    class="grid w-full max-w-screen-xl grid-cols-1 gap-4 px-4 py-4 mx-auto sm:gap-6 sm:py-6 sm:px-8 lg:grid-cols-2"
  >
    <div class="flex flex-col gap-6">
      <ng-content select="[left-content]"></ng-content>
    </div>
    <div class="flex flex-col gap-6" [ngClass]="{ '-order-1 lg:order-1': rightFirstOnDesptop }">
      <ng-content select="[right-content]"></ng-content>
    </div>
  </div>
  <!-- MAIN -->
</div>
<!-- / ACTIVATION VIEW LAYOUT -->
